import { render, staticRenderFns } from "./ReplyFamilyLawStep.vue?vue&type=template&id=2828bd7a"
import script from "./ReplyFamilyLawStep.vue?vue&type=script&lang=ts"
export * from "./ReplyFamilyLawStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports